import { Configuration } from './../../models/Configuration';
import { Action } from "../../models/Action";
import { getConfigurationFacility, updateFacilityIds } from "./configActions";

declare const config: { FACILITY_IDS: string };
export const FACILITY_IDS = (config && config.FACILITY_IDS) || "";

export interface ConfigState {
  facilityIds: string;
  facilityLogoUrl: string;
  configuration: Configuration;
  loading: boolean;
  error: string | null;
}

const initialConfig: ConfigState = {
  facilityIds: sessionStorage.getItem("facilityId") || FACILITY_IDS,
  facilityLogoUrl: "",
  configuration: {} as Configuration,
  loading: false,
  error: null,
};

export default function configReducer(configState = initialConfig, action: Action<any>) {
  switch (action.type) {
    case updateFacilityIds.toString():
      return {
        ...configState,
        facilityIds: action.payload,
      };
    case getConfigurationFacility.pending.toString():
      return {
        ...configState,
        loading: true,
        error: null,
      };
    case getConfigurationFacility.fulfilled.toString():
      return {
        ...configState,
        loading: false,
        facilityLogoUrl: action.payload.logoUrl,
        configuration: action.payload || initialConfig.configuration, // Fallback to initial configuration
      };
    case getConfigurationFacility.rejected.toString():
      return {
        ...configState,
        loading: false,
        error: "Nie udało się załadować konfiguracji sklepu",
        configuration: initialConfig.configuration, // Reset to initial configuration on error
      };
    default:
      return configState;
  }
}
